/* unplugin-vue-components disabled */import script from "./ProjectDetailTop.vue?vue&type=script&lang=ts&setup=true"
export * from "./ProjectDetailTop.vue?vue&type=script&lang=ts&setup=true"

import "./ProjectDetailTop.vue?vue&type=style&index=0&id=af91a120&scoped=true&lang=css"
import "./ProjectDetailTop.vue?vue&type=style&index=1&id=af91a120&lang=scss&scoped=true"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-af91a120"]])

export default __exports__